import * as React from 'react';
export const pauseFilledSvg = React.forwardRef(function pauseFilledSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4 .5a2 2 0 0 1 2 2v11a2 2 0 1 1-4 0v-11a2 2 0 0 1 2-2Zm8 0a2 2 0 0 1 2 2v11a2 2 0 1 1-4 0v-11a2 2 0 0 1 2-2Z',
    }),
  );
});
pauseFilledSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var pauseFilled = {
  category: 'icon',
  colorable: true,
  name: 'pauseFilled',
  svg: pauseFilledSvg,
};
